export default ({ formData, schema, uiSchema }) => {
  const newFormData = formData ? [formData] : [''];
  return { formData: newFormData, schema, uiSchema };
};



// WEBPACK FOOTER //
// ./webpack/components/Document/Form/Builder/changeQuestionType/toTextList/fromText.js